var ACCESS_TOKEN_KEY = "access_token";
var TokenService = {
    setAccessToken: function (token) {
        var pureToken = token.replace(/^Bearer\s+/i, "");
        localStorage.setItem(ACCESS_TOKEN_KEY, pureToken);
    },
    getAccessToken: function () {
        var token = localStorage.getItem(ACCESS_TOKEN_KEY);
        return token ? "Bearer ".concat(token) : null;
    },
    removeAccessToken: function () {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    },
};
export default TokenService;
